module.exports = __webpack_public_path__ + "static/media/image-2-1.0792ae9e.jpeg";